module.exports = __webpack_public_path__ + "img/av037.4baa3ac5.png";